import { apiClient } from './axios';

import type {
  SmsActionConfig,
  CreateSmsActionConfigDto,
  UpdateSmsActionConfigDto,
  SmsActionLog,
} from '@repo/shared-types';

export interface PaginatedLogs {
  data: (SmsActionLog & { results?: unknown[] })[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const smsActionConfigsApi = {
  getAll: async () => {
    const response = await apiClient.get<SmsActionConfig[]>('/sms-action-configs');
    return response.data;
  },

  getOne: async (id: string) => {
    const response = await apiClient.get<SmsActionConfig>(`/sms-action-configs/${id}`);
    return response.data;
  },

  create: async (data: CreateSmsActionConfigDto) => {
    const response = await apiClient.post<SmsActionConfig>('/sms-action-configs', data);
    return response.data;
  },

  update: async (id: string, data: UpdateSmsActionConfigDto) => {
    const response = await apiClient.patch<SmsActionConfig>(`/sms-action-configs/${id}`, data);
    return response.data;
  },

  delete: async (id: string) => {
    await apiClient.delete(`/sms-action-configs/${id}`);
  },

  getLogs: async (configId: string, page = 1, limit = 50) => {
    const response = await apiClient.get<PaginatedLogs>(
      `/sms-action-configs/${configId}/logs?page=${page}&limit=${limit}`,
    );
    return response.data;
  },
};
